import PropTypes from 'prop-types';
import {Icon} from 'components/layout';
import React from 'react';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import Dealer from 'models/dealer';
import {countries} from 'helpers/constants';


const longCountryCodes = {
  CA: 'CAN',
  US: 'USA',
};

class FullAddress extends React.Component {
  static defaultProps = {
    condition: true,
    editMode: true,
    disabled: false,
    delay: 0,
  };

  static propTypes = {
    condition: PropTypes.bool,
    disabled: PropTypes.any,

    changeFunction: PropTypes.func,
    blurFunction: PropTypes.func,
    editMode: PropTypes.bool,
    address: PropTypes.any,
    verified: PropTypes.bool,
    delay: PropTypes.any,
    intl: intlShape.isRequired,
    dealer: PropTypes.instanceOf(Dealer).isRequired,
  };

  state = {
    verified: !!this.props.verified,
    address: this.props.address,
  };

  componentDidMount() {
    // Push address complete initialiations to bottom of stack so it doesn't block execution and page rendering
    // Space them out as well incase there are a lot
    setTimeout(() => {
      var fields = [
        {element: 'Line1', field: 'Line1'},
        {element: 'Line2', field: 'Line2'},
        {element: 'City', field: 'City'},
        {element: 'Province', field: 'Province'},
        {element: 'PostalCode', field: 'PostalCode'},
      ];

      let options = {
        key: 'UU89-DF83-DE28-AY83',
        autoSearch: true,
        setCountryByIP: false,
        culture: (this.props.intl.locale || 'en-US').toLowerCase(),
        // WARNING: Undocumented API, this may break
        countries: {defaultCode: longCountryCodes[this.props.dealer.country] || longCountryCodes.US},
      };

      var control = new window.pca.Address(fields, options);

      control.listen('populate', (address) => {
        this.setState({
          address: address,
          verified: true,
        });

        this.forceUpdate();

        if (this.props.changeFunction) {
          setTimeout(() => this.props.changeFunction(this.state.address, true), 100);
        }
      });

      this.control = control;
    }, 0);
  }

  componentWillUnmount() {
    this.control.destroy();
    this.control = null;
  }

  setUnverifiedAddress = (evt) => {
    var newState = this.state;

    newState.verified = false;
    newState.address[evt.target.id] = evt.target.value;

    this.setState(newState);
    this.forceUpdate();

    if (this.props.changeFunction) {
      setTimeout(() => this.props.changeFunction(this.state.address, false), 100);
    }
  };

  render() {
    let disabled = this.props.disabled;
    let {formatMessage} = this.props.intl;
    const {country} = this.props.dealer;

    if (disabled instanceof Array) {
      disabled = disabled.indexOf(this.props.dataKey) !== -1;
    }

    if (this.props.condition) {
      return (
        <div className='form-group fulladdress' style={this.props.style}>
          <label style={{width: '100%'}}><FormattedMessage id="general.address" /></label>

          <input id="Line1" className={'form-control ' + (!this.state.address.Line1 ? 'error' : '')}
            placeholder={formatMessage({id: 'general.address.one'})}
            defaultValue={this.state.address.Line1}
            disabled={!this.props.editMode}
            onChange={this.setUnverifiedAddress}
            onBlur={this.props.blurFunction}
            maxLength = {50}
            required />

          <input id="Line2" className="form-control"
            placeholder={formatMessage({id: 'general.address.two'})}
            defaultValue={this.state.address.Line2}
            disabled={!this.props.editMode}
            onChange={this.setUnverifiedAddress}
            onBlur={this.props.blurFunction}
            maxLength = {50} />

          <div className="row">
            <div className="col-md-6">
              <input id="City" className={'form-control ' + (!this.state.address.City ? 'error' : '')}
                placeholder={formatMessage({id: 'general.city'})}
                defaultValue={this.state.address.City}
                disabled={!this.props.editMode}
                onChange={this.setUnverifiedAddress}
                maxLength = {50}
                required />
            </div>

            <div className="col-md-6">
              <input id="Province" className={'form-control ' + (!this.state.address.Province ? 'error' : '')}
                placeholder={formatMessage({id: country === countries.CA ? 'general.province' : 'general.state'})}
                defaultValue={this.state.address.Province}
                disabled={!this.props.editMode}
                onChange={this.setUnverifiedAddress}
                maxLength = {3}
                required />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <input id="PostalCode" className={'form-control ' + (!this.state.address.PostalCode ? 'error' : '')}
                placeholder={formatMessage({id: country === countries.CA ? 'general.postal-code' : 'general.zipcode'})}
                defaultValue={this.state.address.PostalCode}
                disabled={!this.props.editMode}
                onChange={this.setUnverifiedAddress}
                maxLength = {10}
                required />
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 address-verified">
              {
                this.state.verified ?
                  <span className="verified"><Icon name='checkmark_circle' /><FormattedMessage id="general.address.verified" /></span> :
                  <span className="not-verified"><Icon name='attention' /><FormattedMessage id="general.address.notverified" /></span>
              }
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

export default injectIntl(FullAddress);
